/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme, FormControl } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import CloseIcon from '@material-ui/icons/Close';
import { formatNumber, getSuggestedMaxTick, GetGroupBy, GetArrow, GetGroupByPlurals } from '../../helpers/ChartHelper';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { DrillDownType } from '../DrillDownType';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvBarDatasetStyle, rvChartAnimation, rvValueAxisStyle, rvCategoryAxisStyle, rvTooltipStyle, isChartDataEmpty, rvLegendLabels } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartLimitNote } from '../ChartLimitNote';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartFootnote } from '../ChartFootnote';
import { ChartEmptyState } from '../ChartEmptyState';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '15px 15px 0px 15px',
            '& .title': {
                fontSize: 16,
            },
            '& .colWrapper': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 15,
                flexFlow: 'row wrap',
            },
            '& .col': {
                fontSize: '16px',
                fontWeight: 600,
                textAlign: 'center',
                border: '1px solid',
                padding: '15px',
                display: 'flex',
                margin: '0 10px 10px 10px',
                flexFlow: 'column',
                flex: 1,
                '& .value': {
                    fontSize: '36px',
                    padding: '20px 0',
                },
                '& .sub': {
                    display: 'flex',
                    flexFlow: 'row wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                '& .status': {
                    marginLeft: '10px',
                    display: 'flex',
                    flexFlow: 'row wrap',
                    alignItems: 'center',
                },
            },
            '& .increase': {
                color: 'green',
            },
            '& .decrease': {
                color: 'red',
            },
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative'
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        groupingTitle: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
            paddingTop: '10px'
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        cursorDiv: {
            cursor: 'pointer',
        }
    }),
);

interface NewMattersInLastTwelveMonthsGroupedChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    groupBy: string;
}

interface ChartState {
    groupedBy: string[];
    lastTwelveMonthsCount: number[];
    lastTwelveMonthsEstimate: number[];
    previousTwelveMonthsCount: number[];
    previousTwelveMonthsEstimate: number[];
    mattersOpenedCount: number;
    mattersOpenedTotalEstimate: number;
    mattersOpenedWithoutEstimate: number;
    prevMattersOpenedCount: number;
    prevMattersOpenedTotalEstimate: number;
    prevMattersOpenedWithoutEstimate: number;
    groupedByCount: number;
    symbol: string;
}

export const NewMattersInLastTwelveMonthsGroupedChart: React.FC<NewMattersInLastTwelveMonthsGroupedChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const { loading, error, data } = useQuery<NewMattersInLastTwelveMonthsData>(NEW_MATTERS_IN_LAST_TWELVE_MONTHS_QUERY, {
        variables: {
            groupBy: props.groupBy,
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords,
            filter: props.chartFilter?.filter,
        },
    });

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    const [state, setState] = useState<ChartState>({
        groupedBy: [],
        lastTwelveMonthsCount: [],
        lastTwelveMonthsEstimate: [],
        previousTwelveMonthsCount: [],
        previousTwelveMonthsEstimate: [],
        mattersOpenedCount: 0,
        mattersOpenedTotalEstimate: 0,
        mattersOpenedWithoutEstimate: 0,
        prevMattersOpenedCount: 0,
        prevMattersOpenedTotalEstimate: 0,
        prevMattersOpenedWithoutEstimate: 0,
        groupedByCount: 0,
        symbol: '$'
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    React.useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    useEffect(() => {
        if (!loading) {
            setState((prevState) => {
                let groupedBy: string[] = [];
                let lastTwelveMonthsCount: number[] = [];
                let lastTwelveMonthsEstimate: number[] = [];
                let previousTwelveMonthsCount: number[] = [];
                let previousTwelveMonthsEstimate: number[] = [];
                let mattersOpenedCount: number = 0;
                let mattersOpenedTotalEstimate: number = 0;
                let mattersOpenedWithoutEstimate: number = 0;
                let prevMattersOpenedCount: number = 0;
                let prevMattersOpenedTotalEstimate: number = 0;
                let prevMattersOpenedWithoutEstimate: number = 0;
                let groupedByCountData: number = 0;

                if (!error && data && data.statistics && data.statistics.matter && data.statistics.matter.newMattersInLastTwelveMonths) {
                    let newMattersInLastTwelveMonthsData = data.statistics.matter.newMattersInLastTwelveMonths;
                    const { newMattersInLastTwelveMonth, previousYearMattersOpenedCountTotal, mattersOpenedCountTotal, groupedByCount } = newMattersInLastTwelveMonthsData;
                    groupedBy = newMattersInLastTwelveMonth.map((c: NewMattersInLastTwelveMonth) => c.groupedBy);
                    lastTwelveMonthsCount = newMattersInLastTwelveMonth.map((c: NewMattersInLastTwelveMonth) => c.lastTwelveMonthsCount);
                    lastTwelveMonthsEstimate = newMattersInLastTwelveMonth.map((c: NewMattersInLastTwelveMonth) => c.lastTwelveMonthsEstimate);
                    previousTwelveMonthsCount = newMattersInLastTwelveMonth.map((c: NewMattersInLastTwelveMonth) => c.previousTwelveMonthsCount);
                    previousTwelveMonthsEstimate = newMattersInLastTwelveMonth.map((c: NewMattersInLastTwelveMonth) => c.previousTwelveMonthsEstimate);

                    mattersOpenedCount = mattersOpenedCountTotal.count;
                    mattersOpenedTotalEstimate = mattersOpenedCountTotal.totalEstimates;
                    mattersOpenedWithoutEstimate = mattersOpenedCountTotal.mattersWithoutEstimate;

                    prevMattersOpenedCount = previousYearMattersOpenedCountTotal.count;
                    prevMattersOpenedTotalEstimate = previousYearMattersOpenedCountTotal.totalEstimates;
                    prevMattersOpenedWithoutEstimate = previousYearMattersOpenedCountTotal.mattersWithoutEstimate;

                    groupedByCountData = groupedByCount;
                }

                return {
                    ...prevState,
                    groupedBy,
                    lastTwelveMonthsCount,
                    lastTwelveMonthsEstimate,
                    previousTwelveMonthsCount,
                    previousTwelveMonthsEstimate,
                    mattersOpenedCount,
                    mattersOpenedTotalEstimate,
                    mattersOpenedWithoutEstimate,
                    prevMattersOpenedCount,
                    prevMattersOpenedTotalEstimate,
                    prevMattersOpenedWithoutEstimate,
                    groupedByCountData
                };
            });
        }
        // tslint:disable-next-line: align
    }, [loading, error, data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            return props.onCloseChart(`isNewMattersInLastTwelveMonthsByReportingGroupChart`);
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize();
        }
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1; 
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };
    
    const onScrollDownAndNext = (type: 'down' | 'next') => {

        const labels = state.groupedBy;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        }  else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        } 
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {  
        const labels = state.groupedBy;
        // up 
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    const onZoom = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('New Matters In Last Twelve Months By Reporting Group Chart'));
        // tslint:disable-next-line: align
        }, 500);
    };

    const chartControllerComponent = () => {
        return (
            <>
<IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    const handleTotalClick = (isCurrent: boolean) => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            searchCriterias.push({ property: '12MonthPeriod', operator: 'eq', comparison: isCurrent ? 'curr' : 'prev' });

            props.getSelectedItem(
                searchCriterias,
                true,
                `New Matters in the last 12 months by ${GetGroupBy(props.groupBy)}`,
                DrillDownType.matterSummaryDrilldown,
                props.groupBy === 'ReportingGroup' ? 'Reporting Group' : 'Matters',
            );
        }
    };

    const handleNoEstimates = (isCurrent: boolean) => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            
            searchCriterias.push({ property: '12MonthPeriod', operator: 'eq', comparison: isCurrent ? 'curr' : 'prev' });

            searchCriterias.push({ property: 'EstimatedCosts', operator: 'eq', comparison: '0' });

            props.getSelectedItem(
                searchCriterias,
                true,
                `New Matters in the last 12 months by ${GetGroupBy(props.groupBy)}`,
                DrillDownType.matterSummaryDrilldown,
                props.groupBy === 'ReportingGroup' ? 'Reporting Group' : 'Matters',
            );
        }
    };

    if (loading || currencySymbolQuery.loading) {
        return (
            <div className="rv-chart rv-chart-loading">
                {chartControllerComponent()}
                <ChartSkeleton variant="bars" />
            </div>
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.previousTwelveMonthsCount, state.lastTwelveMonthsCount) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<DateRangeOutlinedIcon />} title="New Matters in the last 12 months" />
                <div className={`${classes.total} h2`} onClick={() => handleTotalClick(true)}>
                    <AnimatedNumber value={state.mattersOpenedCount} format={(amount) => formatNumber(amount)} />
                    {GetArrow(state.mattersOpenedCount, state.prevMattersOpenedCount)}
                </div>
                <div className={classes.title} onClick={() => handleTotalClick(false)}>
                    {formatNumber(state.prevMattersOpenedCount)} matters opened in the 12 months before that
                </div>
                <div className={classes.groupingTitle}>New Matters by {GetGroupBy(props.groupBy)}</div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('up')}
                                ref={scrollUpAndPrevRef}
                            >
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('down')}
                                ref={scrollDownAndNextRef}
                            >
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;
                            const _datasetIndex = getElementAtEvent(chartRef.current, event)[0].datasetIndex;

                            const item = state.groupedBy[_index];

                            const searchCriterias = new Array<SearchCriteria>();

                            searchCriterias.push(
                                { property: props.groupBy, operator: 'eq', comparison: item },
                                { property: '12MonthPeriod', operator: 'eq', comparison: _datasetIndex === 1 ? 'curr' : 'prev' },
                            );

                            props.getSelectedItem(
                                searchCriterias,
                                true,
                                `New Matters in the last 12 months by ${GetGroupBy(props.groupBy)}`,
                                DrillDownType.matterSummaryDrilldown,
                                props.groupBy === 'ReportingGroup' ? 'Reporting Group' : 'Matters',
                            );
                        }
                    }}
                    data={{
                        labels: state.groupedBy.length > 0 ? state.groupedBy : [''],
                        datasets: [
                            {
                                label: 'Previous 12 months',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primarySoft),
                                data: state.previousTwelveMonthsCount,
                            },
                            {
                                label: 'Current 12 months',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: state.lastTwelveMonthsCount,
                            },
                        // tslint:disable-next-line:no-any
                        ] as any,
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                              // beginAtZero: true,
                              suggestedMax: getSuggestedMaxTick([...state.previousTwelveMonthsCount, ...state.lastTwelveMonthsCount]),
                              beginAtZero: true,
                              ticks: {
                                        ...rvValueAxisStyle.ticks,
                                autoSkip: false,
                                callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                    return `${formatNumber(tickValue)}`;
                                },
                            },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                              // min: 0,
                              // max: 9 // minimum display
                              ticks: {
                                        ...rvCategoryAxisStyle.ticks,
                                  autoSkip: false
                              }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: true,
                                labels: rvLegendLabels,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   label,
                                            formattedValue,
                                        } = context;

                                        var currentValue = parseFloat(formattedValue.replace(/,/g, ''));

                                        return `Matters ${formatNumber(currentValue)}`;
                                    },
                                     // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {
                                        const {
                                            dataIndex,
                                            //   label,
                                            dataset,
                                        } = context;
                                        
                                        var estimateString = '';

                                        if (dataset.label.toLowerCase() === 'current 12 months') {
                                            const currentEstimate = state.lastTwelveMonthsEstimate[dataIndex];

                                            if (currentEstimate && currentEstimate !== 0) {
                                                estimateString = `Estimated Fees ${state.symbol}${formatNumber(currentEstimate)}`;
                                            }
                                        } else {
                                            const currentEstimate = state.previousTwelveMonthsEstimate[dataIndex];

                                            if (currentEstimate && currentEstimate !== 0) {
                                                estimateString = `Estimated Fees ${state.symbol}${formatNumber(currentEstimate)}`;
                                            }
                                        }
                                        return [
                                            `${estimateString}`
                                        ];
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.previousTwelveMonthsCount, state.lastTwelveMonthsCount) && (
                    <ChartEmptyState title="No new matters" hint={"Nothing in the last 12 months."} />
                )}
            </div>
            <FormControl component="div">
                <ChartFootnote
                    rows={[
                        {
                            label: 'Last 12 months',
                            text: (
                                <>
                                    {`${state.symbol}${formatNumber(state.mattersOpenedTotalEstimate)} total estimated fees, `}
                                    <span className={classes.cursorDiv} onClick={() => handleNoEstimates(true)}>{formatNumber(state.mattersOpenedWithoutEstimate)}</span>
                                    {' matters without estimates'}
                                </>
                            ),
                        },
                        {
                            label: 'Before that',
                            text: (
                                <span onClick={() => handleNoEstimates(false)}>
                                    {`${state.symbol}${formatNumber(state.prevMattersOpenedTotalEstimate)} total estimated fees, ${formatNumber(state.prevMattersOpenedWithoutEstimate)} matters without estimates`}
                                </span>
                            ),
                        },
                    ]}
                />
                {state.groupedByCount > 10 && (
                    <ChartLimitNote>The top 10 {GetGroupByPlurals(props.groupBy)} are shown</ChartLimitNote>
                )}
            </FormControl>
        </div>
    );
};
export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export interface Statistics {
    matter: Matter;
}

export interface NewMattersInLastTwelveMonthsData {
    statistics: Statistics;
}

export interface Matter {
    newMattersInLastTwelveMonths: NewMattersInLastTwelveMonths;
}
export interface NewMattersInLastTwelveMonths {
    mattersOpenedCountTotal: MattersTotal;
    previousYearMattersOpenedCountTotal: MattersTotal;
    groupedByCount: number;
    newMattersInLastTwelveMonth: NewMattersInLastTwelveMonth[];
}

export interface NewMattersInLastTwelveMonth {
    lastTwelveMonthsCount: number;
    lastTwelveMonthsEstimate: number;
    previousTwelveMonthsCount: number;
    previousTwelveMonthsEstimate: number;
    groupedBy: string;
}

export interface MattersTotal {
    count: number;
    mattersWithoutEstimate: number;
    totalEstimates: number;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

const NEW_MATTERS_IN_LAST_TWELVE_MONTHS_QUERY = gql`
    query NewMattersInLastTwelveMonthsData($groupBy: MatterGroupBy, $entityType: Int, $entityGuid: String, $responsibility: Int, $filter: String) {
        statistics {
            matter {
                newMattersInLastTwelveMonths(groupBy: $groupBy, entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, filter: $filter) {
                    mattersOpenedCountTotal {
                        count
                        mattersWithoutEstimate
                        totalEstimates
                    }
                    previousYearMattersOpenedCountTotal {
                        count
                        mattersWithoutEstimate
                        totalEstimates
                    }
                    groupedByCount
                    newMattersInLastTwelveMonth {
                        groupedBy
                        lastTwelveMonthsCount
                        lastTwelveMonthsEstimate
                        previousTwelveMonthsCount
                        previousTwelveMonthsEstimate
                    }
                }
            }
        }
    }
`;
